import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useMainStyles = makeStyles((theme: Theme) => ({
    card: {
        background: `${theme.palette.primary.main} !important`,
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15) !important",
        borderRadius: "4px !important",
        "&::before": {
            content: "none !important",
        },
        "& .Mui-expanded": {
            minHeight: "0 !important",
        },
    },
    mainWrapperHeaderTitle: {
        color: theme.palette.info.main,
        fontSize: "18px",
        fontWeight: 400,
        padding: "14px 32px 0 32px",
    },
    cardBody: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
    },
}));
